export default __webpack_public_path__ + "static/media/05_cosmos.7b06d2bf.webp";